import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function ManageAdvertiseMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
          ${sidebarHelper.checkOpenItem(openItem, "manage-advertise")} `}
    >
      <a
        href="# "
        className={`nav-link  
          ${sidebarHelper.checkActiveItem(openItem, "manage-advertise")} `}
      >
        <i className="nav-icon fa fa-tasks "></i>
        <p>
          مدیریت تبلیغات
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/advertise/manage/banner/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-advertise-banner"
              )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>تبلیغات بنری</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/advertise/manage/native/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-advertise-native"
              )} `}
          >
            <i className="fa fa-file nav-icon"></i>
            <p>تبلیغات همسان</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-advertise-push"
              )} `}
          >
            <i className="fa fa-bell nav-icon"></i>
            <p>تبلیغات پوش</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
export default ManageAdvertiseMenu;
